<template>
  <section ref="element" :class='{fade: active}'>
    <slot />
  </section>
</template>

<script setup>
import { useScroll } from '@vueuse/core'
import { useElementBounding } from '@vueuse/core'

const props = defineProps({
  active: {
    default: true,
  },
  offset: {
    type: Number,
    default: 0,
  },
  threshold: {
    type: Number,
    default: 300,
  },
});

const element = ref();
const {top, height} = useElementBounding(element, { throttle: 100 })
const {y} = useScroll(window, { throttle: 100 })

// Clamp function to ensure value is between 0 and 1
const clamp = (value) => Math.max(0, Math.min(1, value));

const intro = computed(() => {
  const distance = window.innerHeight - top.value;
  if (distance < props.threshold) {
    return clamp((distance + props.offset) / props.threshold);
  }
  return 1;
});

const outro = computed(() => {
  const distance = top.value + height.value - props.offset;
  if (distance < props.threshold) {
    return clamp(distance / props.threshold);
  }
  return 1;
});

const introOrOutro = computed(() => {
  if (intro.value < 1) return intro.value;
  if (outro.value < 1) return outro.value;
  return 1;
});
</script>

<style scoped>
  section.fade {
    opacity: v-bind(introOrOutro);
    /*transform: translateY(calc(-50px * v-bind(introOrOutro)));*/
  }
</style>
